import { useTranslation } from 'react-i18next';
import type { ItineraryDay } from '../../types';

interface Props {
  days: ItineraryDay[];
  value: string | null;
  disabled: boolean;
  onPick: (dayId: string) => void;
}

/** Which day a day map draws (ADR-0047). */
export default function AlbumDayPicker({ days, value, disabled, onPick }: Props) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-5 gap-1.5" role="radiogroup" aria-label={t('album.chooseDay')}>
      {days.map(day => (
        <button
          key={day.id}
          role="radio"
          aria-checked={value === day.id}
          disabled={disabled}
          onClick={() => onPick(day.id)}
          title={day.title ?? undefined}
          className={`rounded-lg py-2 text-xs font-semibold cursor-pointer disabled:opacity-50 ${
            value === day.id
              ? 'bg-slate-900 text-white dark:bg-white dark:text-slate-900'
              : 'bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700'
          }`}
        >
          {t('album.dayN', { n: day.dayNumber })}
        </button>
      ))}
    </div>
  );
}
